import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { SpeedDialModule } from 'primeng/speeddial';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { OverlayModule } from 'primeng/overlay';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TooltipModule } from 'primeng/tooltip';
import { LoaderModule } from './core/loader/loader.module';
import { AccordionModule } from './modules/components/accordion/accordion.module';
import { ComponentsModule } from './modules/components/components.module';
import { DirectivesModule } from './modules/directives/directives.module';

import { PipesModule } from './modules/pipes/pipes.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PanelModule } from 'primeng/panel';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { PaginatorModule } from 'primeng/paginator';
import { TreeModule } from 'primeng/tree';

import { TextareaModule } from 'primeng/textarea';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TieredMenu } from 'primeng/tieredmenu';


@NgModule({
    imports: [
        CommonModule,
        LoaderModule,
        ComponentsModule,
        DirectivesModule,
        PipesModule,
        TableModule,
        DatePickerModule,
        DialogModule,
        CheckboxModule,
        ListboxModule,
        MultiSelectModule,
        InputNumberModule,
        SelectModule,
        TooltipModule,
        OverlayModule,
        MenuModule,
        MessageModule,
        ProgressBarModule,
        RadioButtonModule,
        CarouselModule,
        // GMapModule,
        SelectButtonModule,
        ConfirmDialogModule,
        SplitButtonModule,
        ScrollingModule,
        StepsModule,
        TieredMenuModule,
        AccordionModule,
        ClipboardModule,
        PanelModule,
        ToggleSwitchModule,
        SpeedDialModule,
        InputGroupModule,
        InputGroupAddonModule,
        ToastModule,
        PaginatorModule,
        TreeModule,
        TextareaModule,
        RouterLinkActive,
        RouterLink,
        RouterLinkActive,
        IconField,
        InputIcon,
        TieredMenu,
    ],
    exports: [
        CommonModule,
        LoaderModule,
        ComponentsModule,
        DirectivesModule,
        PipesModule,
        TableModule,
        DatePickerModule,
        DialogModule,
        CheckboxModule,
        ListboxModule,
        MultiSelectModule,
        InputNumberModule,
        SelectModule,
        TooltipModule,
        OverlayModule,
        MenuModule,
        MessageModule,
        MessageModule,
        ProgressBarModule,
        RadioButtonModule,
        CarouselModule,
        // GMapModule,
        SelectButtonModule,
        ConfirmDialogModule,
        SplitButtonModule,
        ScrollingModule,
        StepsModule,
        TieredMenuModule,
        AccordionModule,
        ClipboardModule,
        PanelModule,
        ToggleSwitchModule,
        SpeedDialModule,
        InputGroupModule,
        InputGroupAddonModule,
        ToastModule,
        TextareaModule,
        RouterLinkActive,
        RouterLink,
        RouterLinkActive,
        IconField,
        InputIcon,
        TieredMenu,
    ],
    providers: [ConfirmationService]
})
export class SharedModule { }
